import appLogo from '../../../assets/applogo.png';
import './css/FooterSection.css';
import { environment } from 'src/environment/environment';
import pdfDownload from '../../../assets/download-pdf.png';

const FooterSection = (props: { invoiceData: any; shopFields: any }) => {
  const { invoiceData, shopFields } = props;

  const openPDF = () => {
    window.open(
      `${environment.pdf_url}/api/public/pdf/${invoiceData?._id}`,
      '_blank'
    );
  };

  return (
    <>
      {
        invoiceData?.specialNote != null && invoiceData?.specialNote != undefined && invoiceData?.specialNote != "" &&
        <>
          <div className="border-line-1"></div>
        
          <div className='short-notes'>
            {invoiceData?.specialNote}
          </div>
        </>
      }

      {
        invoiceData?.shortNotes != null && invoiceData?.shortNotes != undefined && invoiceData?.shortNotes != "" &&
        <>
          <div className="border-line-1"></div>
        
          <div className='short-notes'>
            {invoiceData?.shortNotes}
          </div>
        </>
      }

      {
        shopFields?.shopInfo != '' && shopFields?.shopInfo != undefined && shopFields?.shopInfo != null &&
        <>
          <div className="border-line-1"></div>
          <div className='shop-info'>{shopFields?.shopInfo}</div>
        </>
      }
      
      <div className="border-line" style={{backgroundImage: `linear-gradient(to right, ${shopFields?.firstThemeColor ?? `#976bdb`}, ${shopFields?.secondThemeColor ?? `#f63b95`})`}}></div>
      
      <div className="footer-container">
        <div className='footer-main-s1'>
          <div className="footer-s2">
            <div className="budget-app-logo">
              <a href="https://fanbudget.lk/" target="_blank" rel="noopener noreferrer">
                <img src={appLogo} alt="FanBudget Logo" />
              </a>
            </div>
          </div>

          <a href="https://fanbudget.lk/" target="_blank" rel="noopener noreferrer" className='link-logo'>
            <div className="footer-s1">
              &nbsp; Software By FanBudget
            </div>
          </a>
        </div>
        <div className="footer-main-s2">
          <div className="download-pdf-div">
            <img src={pdfDownload} alt="PDF Download" className="pdf-download" onClick={openPDF} />
          </div>
        </div>
      </div>
    </>
  );
};

export default FooterSection;
